function MainProductFactory(container) {
  let MainProduct = class {
    constructor(container) {
      this.section = container;
      this._init();
    }
    _init() {
      this.#setEvents();
      this.#buildResponsiveLayout();
    }

    #setEvents() {
      window.addEventListener("resize", () => {
        this.#buildResponsiveLayout();
      });
    }
    #buildResponsiveLayout() {
      const description = this.section.querySelector(".ProductMeta__ShortDesc");
      const descriptionAreaAtMobile = this.section.querySelector(
        ".Product__ShortDesc--mobile",
      );
      const descriptionAreaAtDesktop = this.section.querySelector(
        ".Product__ShortDesc--desktop",
      );
      return;
      if (window.matchMedia("(min-width: 1280px)").matches) {
        if (!descriptionAreaAtDesktop.contains(description)) {
          descriptionAreaAtDesktop.appendChild(description);
        }
      } else {
        if (!descriptionAreaAtMobile.contains(description)) {
          descriptionAreaAtMobile.appendChild(description);
        }
      }
    }
  };
  return new MainProduct(container);
}
